import React from 'react'

const MinusSvg = () => (
  <svg width="18" height="2" viewBox="0 0 18 2">
    <path d="M0 0h18v2H0z" />
  </svg>
)

export default MinusSvg
